import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/lecture?page=1&maxData=1000&type=' // (21)강의목록 조회
// type = 0: 전체, 1: 초등, 2: 중등, 3: 고등, 4: n수

let swrData: any = getPersistData(KEY)

export function useLectureList(type) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + type,
		async () => {
			const response = await API.get(KEY + type, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		LectureListData: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}
